import React, { Component } from 'react';
import { observer } from 'mobx-react';
import home from '../../store/index.js';
import fisttitle from '../../static/images/fisttitle.png';
import roof from '../../static/images/roof.png';
import square from '../../static/images/square.png';

import './index.css'
@observer
class Fister extends Component {
    go() {
        home.secoedlogin(true)
    }
    render() {
        return (
            <div className='firstEnter'>
                <div className='fistCenter'>
                    <div className='fistCenter_s'>
                        <div className='fistCenter_t_t'>
                            <i className='fistCenter_t_t_t'>
                                <img src={fisttitle} alt="" />
                            </i>
                            <i className='fistCenter_t_t_c'>
                                <img src={roof} alt="" />
                            </i>
                        </div>
                        <div className='fistCenter_t_c'>
                            <img src={square} alt="" />
                            <span>在这里匿名倾诉你的职场困惑，专业解忧人将为你解忧！</span>
                            <span>职场再多苦涩，有我们给你一点甜~</span>
                        </div>
                    </div>
                    <button onClick={() => { this.go() }}>我知道了</button>
                </div>
            </div >
        )
    }
}
export default Fister